function initDoseTestimonialsSliders(scope) {
  const root = scope || document;
  const sliders = root.querySelectorAll('.dose-reviews__slider.swiper');

  sliders.forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;

    const section = slider.closest('.dose-reviews');
    if (!section) return;

    const nextEl = section.querySelector('.dose_navigation .dose-swiper-button-next');
    const prevEl = section.querySelector('.dose_navigation .dose-swiper-button-prev');
    const paginationEl = section.querySelector('.dose-reviews__pagination');

    new Swiper(slider, {
      cssMode: true,
      breakpoints: {
        320: { slidesPerView: 1.1 },
        768: { slidesPerView: 2.1 },
        1024: { slidesPerView: 3.1 }
      },
      navigation: {
        nextEl,
        prevEl
      },
      pagination: {
        el: paginationEl,
        clickable: true
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initDoseTestimonialsSliders(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initDoseTestimonialsSliders(event.target);
});
